export default __webpack_public_path__ + "static/ILCT_logo-a020ca66c90f3f948871720e8b59830a.png";